__turbopack_context__.v({
  "className": "label_d5befc7e-module__asLVIW__className",
  "variable": "label_d5befc7e-module__asLVIW__variable",
});
